import * as ed25519 from '@noble/ed25519';

class KeypairIdentityDriver {
  constructor(keypair) {
    this.keypair = keypair;
    this.publicKey = keypair.publicKey;
    this.secretKey = keypair.secretKey;
  }
  async signMessage(message) {
    return ed25519.sync.sign(message, this.secretKey.slice(0, 32));
  }
  async signTransaction(transaction) {
    transaction.partialSign(this.keypair);
    return transaction;
  }
  async signAllTransactions(transactions) {
    return Promise.all(transactions.map(transaction => this.signTransaction(transaction)));
  }
}

export { KeypairIdentityDriver };
//# sourceMappingURL=KeypairIdentityDriver.mjs.map
